import { Article } from "@/features/search/types/search";

interface writeNewsletterProps {
  userName: string;
  interests: string[];
  articles: Article[];
  tone: string;
  toneFeedback: string;
}
export const writeNewsletter = async (props: writeNewsletterProps) => {
  try {
    const response = await fetch(
      "https://supabase-worker.marsescobin.workers.dev/api/write-newsletter",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          userName: props.userName,
          interests: props.interests,
          articles: props.articles,
          tone: props.tone,
          toneFeedback: props.toneFeedback,
        }),
      }
    );
    return response;
  } catch (error) {
    console.error("Error writing newsletter:", error);
    throw error;
  }
};
